import React from 'react'

export default function Pagination({ page, pageSize, total, onPageChange }){
  const totalPages = Math.max(1, Math.ceil(total / pageSize))
  const prev = () => onPageChange(Math.max(1, page - 1))
  const next = () => onPageChange(Math.min(totalPages, page + 1))

  return (
    <div className="pagination">
      <button className="page-btn" onClick={prev} disabled={page<=1}>Prev</button>
      <span className="page-indicator">Page {page} / {totalPages}</span>
      <button className="page-btn" onClick={next} disabled={page>=totalPages}>Next</button>
    </div>
  )
}
